import Typography from '@mui/material/Typography';
import { useContainerCore } from '../../../../core/modules/container';
import { useCallback, useState, useEffect } from 'react';
import { useCompanyCore } from '../../../../core/modules/company';
import { useMasterCore } from '../../../../core/modules/master';
import { Button } from '@mui/material';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { AdvancedFilters } from './AdvancedFilters';
import { GetContainersParams } from '../../../../core/modules/container/interfaces/get-containers';
import { useGlobalCore } from '../../../../core/modules/global';
import { CREATE_CONTAINER_DIALOG } from '../../../../core/constants/dialog';
import { useMeCore } from '../../../../core/modules/me';
import { useBusinessCore } from '../../../../core/modules/business';

const Header = () => {
  const { total, options, getContainers, setOptions } = useContainerCore();
  const { companyId } = useCompanyCore();
  const { user } = useMeCore();
  const { openDialog } = useGlobalCore();
  const { getBusinesses } = useBusinessCore();
  const { getTypes, getCategories, getPriceRanges } = useMasterCore();
  
  // Cargar tipos de recipiente
  useEffect(() => {
    if (companyId) {
      getTypes(companyId, 'containerRecipient');
    }
  }, [companyId, getTypes]);

  const [loading, setLoading] = useState(false);

  const canWrite = useCallback(
    () => user && (user.privileges.superAdmin || user.privileges.writeContainer),
    [user]
  );

  const handleAdvancedFiltersChange = useCallback((filters: GetContainersParams) => {
    // Actualizar el estado global de filtros
    setOptions(filters);
  }, [setOptions]);

  const handleApplyAdvancedFilters = useCallback(() => {
    if (companyId) {
      setLoading(true);
      
      // Usar los filtros del estado global
      const combinedFilters: GetContainersParams = {
        ...options,
        page: 1,
      };
      
      console.log('Filtros combinados enviados al backend:', combinedFilters);
      
      getContainers(
        companyId,
        combinedFilters,
        () => {
          setLoading(false);
        },
        () => {
          setLoading(false);
        }
      );
    }
  }, [companyId, options, getContainers]);

  const handleClearAdvancedFilters = useCallback(() => {
    // Limpiar filtros en el estado global
    setOptions({ page: 1 });
    if (companyId) {
      setLoading(true);
      getContainers(
        companyId,
        { page: 1 },
        () => {
          setLoading(false);
        },
        () => {
          setLoading(false);
        }
      );
    }
  }, [companyId, getContainers, setOptions]);

  const openCreateDialog = useCallback(() => {
    if (companyId) {
      getBusinesses(companyId);
      getTypes(companyId, 'container');
      getCategories(companyId, 'container');
      getTypes(companyId, 'channel');
      getPriceRanges(companyId);
    }
    openDialog(CREATE_CONTAINER_DIALOG);
  }, [companyId, getBusinesses, getCategories, getPriceRanges, getTypes, openDialog]);

  // Cargar contenedores usando los filtros actuales
  useEffect(() => {
    if (companyId) {
      setLoading(true);
      getContainers(
        companyId,
        options,
        () => {
          setLoading(false);
        },
        () => {
          setLoading(false);
        }
      );
    }
  }, [companyId, getContainers, options]);

  return (
    <div className="p-24 sm:p-32 w-full border-b-1 bg-white header-components">
      <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="flex flex-col items-center sm:items-start">
          <Typography className="text-24 md:text-32 font-extrabold tracking-tight leading-none">
            Contenedores vigentes
          </Typography>
          <Typography className="text-14 font-medium" color="text.secondary">
            {total} contenedor/es
          </Typography>
        </div>
        <div className="flex w-full sm:w-auto items-center gap-4 mt-4 sm:mt-0">
          <div className="flex flex-col w-full">
            <div className="flex w-full items-center gap-4">
              {/* Filtros Avanzados */}
              <AdvancedFilters
                filters={options}
                onFiltersChange={handleAdvancedFiltersChange}
                onApplyFilters={handleApplyAdvancedFilters}
                onClearFilters={handleClearAdvancedFilters}
                loading={loading}
              />

              {canWrite() && (
                <Button
                  variant="contained"
                  color="secondary"
                  className="my-auto mx-2"
                  disabled={!companyId}
                  onClick={openCreateDialog}
                  sx={{
                    minWidth: 120,
                    height: 48,
                    fontWeight: 700,
                    fontSize: 16,
                    borderRadius: 999,
                    boxShadow: '0 2px 8px 0 rgba(80,80,200,0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <AddCircleOutlineOutlinedIcon sx={{ fontSize: 22 }} />
                  <span className="mx-8">Crear</span>
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
